import React from 'react';
import Tabs from '../Tabs/Tabs';
import DataSourceBuilderWorkspace from './DataSourceBuilderWorkspace';
import ModalButtons from '../ModalButtons/ModalButtons';

export default class DataSourceBuilder extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      activeTab: 'general',
      data_source: this.props.data_source,
      // file_upload_group: null,
      csvs_data_table_path: this.props.csvs_data_table_path,
      error: null,
    };
    this.onChangeFileUploadGroup = this.onChangeFileUploadGroup.bind(this)
    this.onChange = this.onChange.bind(this);
    this.onChangeTab = this.onChangeTab.bind(this);
    this.onChangeSourceDetail = this.onChangeSourceDetail.bind(this);
  };

  render(){
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick:  () => {
          this.onSave();
        },
      },
    ]

    return(
        <div ref="root" className="panel panel-form DataSourceBuilder">
          <Tabs tabs={this.tabs()} />
          <DataSourceBuilderWorkspace {...this.state} onChange={this.onChange} onChangeInput={this.onChange} onChangeFileUploadGroup={this.onChangeFileUploadGroup} read_only={this.props.read_only} date_formats={this.props.date_formats} time_formats={this.props.time_formats} onChangeSourceDetail={this.onChangeSourceDetail}/>
          <ModalButtons loading={this.state.loading} buttons={buttons} />
        </div>
    );
  };

  tabs() {
    return (
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.activeTab === 'general' ? 'active' : null,
          changeHandler: this.onChangeTab,
        },
        {
          tabName: I18n.t('columns'),
          targetName: 'columns',
          classes: this.state.activeTab === 'columns' ? 'active' : null,
          changeHandler: this.onChangeTab,
        },
      ]
    );
  };


  /////////////// onChange Functions////////////////////
  onChangeFileUploadGroup(value){

    $.ajax({
      type: 'POST',
      url: '/admin/reports/data-sources-file-column-heads',
      data: {
        data_source: this.state.data_source,
        file_upload_group: JSON.stringify(value)
      }
    }).done((data) => {
      this.setState({
        data_source: data.data_source,
        // file_upload_group: data.file_upload_group
      })
      // console.log(data)
    })
  };

  onChange(value, field){
    var updatedDataSource = JSON.parse(JSON.stringify(this.state.data_source))

    updatedDataSource[field] = value
    
    this.setState({
      data_source: updatedDataSource
    });
  };

  onChangeSourceDetail(value, field, sourceDetailColumnName){
    var updatedDataSource = JSON.parse(JSON.stringify(this.state.data_source))

    updatedDataSource.source_details = updatedDataSource.source_details.map((sourceDetail)=>{
      sourceDetail.data_column_name === sourceDetailColumnName ? sourceDetail[field] = value : null
      return sourceDetail
    });

    this.setState({
      data_source: updatedDataSource
    });
  };

  onChangeTab(value) {
    this.setState({
      activeTab: value,
    });
  };

  ////////////// Ajax Calls /////////////////

  onSave() {
    var param_data_source = JSON.parse(JSON.stringify(this.state.data_source));
    param_data_source.source_details = param_data_source.source_details.map(detail => JSON.stringify(detail));
    console.log('param_data_source', param_data_source)
    param_data_source.file_upload_group = param_data_source.file_upload_group ? param_data_source.file_upload_group.csvs.map(upload => JSON.stringify(upload)) : null;

    $.ajax({
      type: this.props.new_record ? 'POST' : 'PATCH',
      url: this.props.form_action,
      data: {
        data_source: param_data_source,
        file_upload_group: JSON.stringify(this.state.file_upload_group)
      }
    }).done((data) => {
      if (data.success) {

        // this.setState({ loading: false });
        if (parent && parent.refresh_data) {
          parent.refresh_data(I18n.t('data_source_saved'));
        }

        if (parent && parent.hide_modal) {
          parent.hide_modal();
        }
      }

      if (data.errors) {
        this.setState({
          errors: data.errors
        });
      };

    });
  };


};